import React from 'react';
import { Link } from 'react-router-dom';
import { Spinner } from '../../components/ui';
import { fmtDate, fmtTime, money } from '../../utils/helpers';
import { isPerUnit } from '../services/useServices';

const statusChip = (s) => s === 'Done' ? 'chip ok' : s === 'Confirmed' ? 'chip male' : s === 'Cancelled' ? 'chip danger' : 'chip pend';

// Mobile "My Work" — the owner's own jobs: when, where, how many, how much.
export default function MyWorkMobile({ vm }) {
  const { byEvent, rows, totals, loading, savingId, confirmCount, mapsHref, user } = vm;

  if (loading) return <div className="card card-pad"><Spinner /></div>;

  return (
    <div>
      <div className="mobile-toolbar">
        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
          <strong style={{ fontSize: 16 }}>My Work</strong>
          <span className="muted" style={{ fontSize: 12 }}>{rows.length}</span>
        </div>
        <div className="muted" style={{ fontSize: 12 }}>{[user?.Surname, user?.Name].filter(Boolean).join(' ')}</div>
      </div>

      {rows.length === 0 ? (
        <div className="card card-pad empty" style={{ padding: '26px 16px' }}>
          <div style={{ fontSize: 30 }}>📋</div>
          <div style={{ fontWeight: 700, color: 'var(--ink)', marginTop: 6 }}>Nothing assigned yet</div>
          <div style={{ fontSize: 13, marginTop: 4 }}>When the organiser books you for a function it appears here.</div>
        </div>
      ) : (
        <>
          <div className="card guest-stats-compact">
            <strong>{money(totals.total)}</strong> agreed | <strong>{money(totals.paid)}</strong> received | <strong>{money(totals.balance)}</strong> pending
          </div>

          {byEvent.map(ev => (
            <div key={ev.EventId}>
              <div className="step-label" style={{ marginTop: 10 }}>{ev.EventName}</div>
              <div className="mobile-card-list">
                {ev.items.map(row => {
                  const maps = mapsHref(row);
                  return (
                    <div key={row.ServiceId} className="card card-pad mobile-record-card">
                      <div className="mobile-card-head">
                        <div style={{ minWidth: 0 }}>
                          <strong className="mobile-title">{row.FunctionName || 'Whole event'}</strong>
                          <div className="muted" style={{ fontSize: 12 }}>{row.ServiceType}</div>
                        </div>
                        <div style={{ flex: 1 }} />
                        <span className={statusChip(row.Status)}>{row.Status}</span>
                      </div>
                      <div className="mobile-meta">
                        <div>📅 {fmtDate(row.FunctionDate || row.ServiceDate)}</div>
                        <div>🕒 {fmtTime(row.StartTime || row.FunctionStartTime) || '—'}
                          {(row.EndTime || row.FunctionEndTime) ? ` – ${fmtTime(row.EndTime || row.FunctionEndTime)}` : ''}</div>
                        {(row.Venue || row.City) && <div>📍 {[row.Venue, row.VenueAddress, row.City].filter(Boolean).join(', ')}</div>}
                        {maps && <div><a href={maps} target="_blank" rel="noreferrer">🗺️ Open in Maps</a></div>}
                        <div>
                          {isPerUnit(row.RateType)
                            ? <>{money(row.Rate)} × <strong>{row.ConfirmedCount}</strong> = {money(row.TotalAmount)}</>
                            : <>Agreed <strong>{money(row.TotalAmount)}</strong></>}
                        </div>
                        <div className="muted">Received {money(row.AdvancePaid)} · Pending <strong>{money(row.BalanceAmount)}</strong></div>
                      </div>

                      {isPerUnit(row.RateType) && row.Status !== 'Done' && (
                        <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                          <input type="number" inputMode="numeric" defaultValue={row.ConfirmedCount}
                            id={`cnt-${row.ServiceId}`} aria-label="Count you will serve"
                            style={{ flex: 1, fontSize: 17, padding: 11, border: '1px solid var(--line)', borderRadius: 10 }} />
                          <button className="btn primary" disabled={savingId === row.ServiceId}
                            onClick={() => confirmCount(row, document.getElementById(`cnt-${row.ServiceId}`).value)}>
                            {savingId === row.ServiceId ? '…' : 'Confirm'}
                          </button>
                        </div>
                      )}
                      <div className="mobile-actions">
                        <Link className="btn light sm" to={`/app/services/${row.ServiceId}`}>Menu / jobs</Link>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          ))}
        </>
      )}
    </div>
  );
}
